module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-07-09",
		"endpointPrefix": "apigateway",
		"protocol": "rest-json",
		"serviceFullName": "Amazon API Gateway",
		"signatureVersion": "v4",
		"uid": "apigateway-2015-07-09"
	},
	"operations": {
		"CreateApiKey": {
			"http": {
				"requestUri": "/apikeys",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"members": {
					"name": {},
					"description": {},
					"enabled": {
						"type": "boolean"
					},
					"generateDistinctId": {
						"type": "boolean"
					},
					"value": {},
					"stageKeys": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"restApiId": {},
								"stageName": {}
							}
						}
					},
					"customerId": {}
				}
			},
			"output": {
				"shape": "S6"
			}
		},
		"CreateAuthorizer": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/authorizers",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"name",
					"type",
					"identitySource"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"name": {},
					"type": {},
					"providerARNs": {
						"shape": "Sb"
					},
					"authType": {},
					"authorizerUri": {},
					"authorizerCredentials": {},
					"identitySource": {},
					"identityValidationExpression": {},
					"authorizerResultTtlInSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"shape": "Se"
			}
		},
		"CreateBasePathMapping": {
			"http": {
				"requestUri": "/domainnames/{domain_name}/basepathmappings",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName",
					"restApiId"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					},
					"basePath": {},
					"restApiId": {},
					"stage": {}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"CreateDeployment": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/deployments",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {},
					"stageDescription": {},
					"description": {},
					"cacheClusterEnabled": {
						"type": "boolean"
					},
					"cacheClusterSize": {},
					"variables": {
						"shape": "Sk"
					}
				}
			},
			"output": {
				"shape": "Sl"
			}
		},
		"CreateDocumentationPart": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/documentation/parts",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"location",
					"properties"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"location": {
						"shape": "Sq"
					},
					"properties": {}
				}
			},
			"output": {
				"shape": "St"
			}
		},
		"CreateDocumentationVersion": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/documentation/versions",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationVersion"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationVersion": {},
					"stageName": {},
					"description": {}
				}
			},
			"output": {
				"shape": "Sv"
			}
		},
		"CreateDomainName": {
			"http": {
				"requestUri": "/domainnames",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName"
				],
				"members": {
					"domainName": {},
					"certificateName": {},
					"certificateBody": {},
					"certificatePrivateKey": {},
					"certificateChain": {},
					"certificateArn": {}
				}
			},
			"output": {
				"shape": "Sx"
			}
		},
		"CreateModel": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/models",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"name",
					"contentType"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"name": {},
					"description": {},
					"schema": {},
					"contentType": {}
				}
			},
			"output": {
				"shape": "Sz"
			}
		},
		"CreateRequestValidator": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/requestvalidators",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"name": {},
					"validateRequestBody": {
						"type": "boolean"
					},
					"validateRequestParameters": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "S11"
			}
		},
		"CreateResource": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/resources/{parent_id}",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"parentId",
					"pathPart"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"parentId": {
						"location": "uri",
						"locationName": "parent_id"
					},
					"pathPart": {}
				}
			},
			"output": {
				"shape": "S13"
			}
		},
		"CreateRestApi": {
			"http": {
				"requestUri": "/restapis",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"name"
				],
				"members": {
					"name": {},
					"description": {},
					"version": {},
					"cloneFrom": {},
					"binaryMediaTypes": {
						"shape": "S8"
					}
				}
			},
			"output": {
				"shape": "S1g"
			}
		},
		"CreateStage": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/stages",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName",
					"deploymentId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {},
					"deploymentId": {},
					"description": {},
					"cacheClusterEnabled": {
						"type": "boolean"
					},
					"cacheClusterSize": {},
					"variables": {
						"shape": "Sk"
					},
					"documentationVersion": {}
				}
			},
			"output": {
				"shape": "S1i"
			}
		},
		"CreateUsagePlan": {
			"http": {
				"requestUri": "/usageplans",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"name"
				],
				"members": {
					"name": {},
					"description": {},
					"apiStages": {
						"shape": "S1q"
					},
					"throttle": {
						"shape": "S1s"
					},
					"quota": {
						"shape": "S1t"
					}
				}
			},
			"output": {
				"shape": "S1v"
			}
		},
		"CreateUsagePlanKey": {
			"http": {
				"requestUri": "/usageplans/{usageplanId}/keys",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId",
					"keyId",
					"keyType"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"keyId": {},
					"keyType": {}
				}
			},
			"output": {
				"shape": "S1x"
			}
		},
		"DeleteApiKey": {
			"http": {
				"method": "DELETE",
				"requestUri": "/apikeys/{api_Key}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"apiKey"
				],
				"members": {
					"apiKey": {
						"location": "uri",
						"locationName": "api_Key"
					}
				}
			}
		},
		"DeleteAuthorizer": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"authorizerId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"authorizerId": {
						"location": "uri",
						"locationName": "authorizer_id"
					}
				}
			}
		},
		"DeleteBasePathMapping": {
			"http": {
				"method": "DELETE",
				"requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName",
					"basePath"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					},
					"basePath": {
						"location": "uri",
						"locationName": "base_path"
					}
				}
			}
		},
		"DeleteClientCertificate": {
			"http": {
				"method": "DELETE",
				"requestUri": "/clientcertificates/{clientcertificate_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"clientCertificateId"
				],
				"members": {
					"clientCertificateId": {
						"location": "uri",
						"locationName": "clientcertificate_id"
					}
				}
			}
		},
		"DeleteDeployment": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"deploymentId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"deploymentId": {
						"location": "uri",
						"locationName": "deployment_id"
					}
				}
			}
		},
		"DeleteDocumentationPart": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationPartId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationPartId": {
						"location": "uri",
						"locationName": "part_id"
					}
				}
			}
		},
		"DeleteDocumentationVersion": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationVersion"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationVersion": {
						"location": "uri",
						"locationName": "doc_version"
					}
				}
			}
		},
		"DeleteDomainName": {
			"http": {
				"method": "DELETE",
				"requestUri": "/domainnames/{domain_name}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					}
				}
			}
		},
		"DeleteIntegration": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					}
				}
			}
		},
		"DeleteIntegrationResponse": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					}
				}
			}
		},
		"DeleteMethod": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					}
				}
			}
		},
		"DeleteMethodResponse": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					}
				}
			}
		},
		"DeleteModel": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/models/{model_name}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"modelName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"modelName": {
						"location": "uri",
						"locationName": "model_name"
					}
				}
			}
		},
		"DeleteRequestValidator": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"requestValidatorId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"requestValidatorId": {
						"location": "uri",
						"locationName": "requestvalidator_id"
					}
				}
			}
		},
		"DeleteResource": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					}
				}
			}
		},
		"DeleteRestApi": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					}
				}
			}
		},
		"DeleteStage": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					}
				}
			}
		},
		"DeleteUsagePlan": {
			"http": {
				"method": "DELETE",
				"requestUri": "/usageplans/{usageplanId}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					}
				}
			}
		},
		"DeleteUsagePlanKey": {
			"http": {
				"method": "DELETE",
				"requestUri": "/usageplans/{usageplanId}/keys/{keyId}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId",
					"keyId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"keyId": {
						"location": "uri",
						"locationName": "keyId"
					}
				}
			}
		},
		"FlushStageAuthorizersCache": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/cache/authorizers",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					}
				}
			}
		},
		"FlushStageCache": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/cache/data",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					}
				}
			}
		},
		"GenerateClientCertificate": {
			"http": {
				"requestUri": "/clientcertificates",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"members": {
					"description": {}
				}
			},
			"output": {
				"shape": "S2k"
			}
		},
		"GetAccount": {
			"http": {
				"method": "GET",
				"requestUri": "/account"
			},
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"shape": "S2m"
			}
		},
		"GetApiKey": {
			"http": {
				"method": "GET",
				"requestUri": "/apikeys/{api_Key}"
			},
			"input": {
				"type": "structure",
				"required": [
					"apiKey"
				],
				"members": {
					"apiKey": {
						"location": "uri",
						"locationName": "api_Key"
					},
					"includeValue": {
						"location": "querystring",
						"locationName": "includeValue",
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "S6"
			}
		},
		"GetApiKeys": {
			"http": {
				"method": "GET",
				"requestUri": "/apikeys"
			},
			"input": {
				"type": "structure",
				"members": {
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"nameQuery": {
						"location": "querystring",
						"locationName": "name"
					},
					"customerId": {
						"location": "querystring",
						"locationName": "customerId"
					},
					"includeValues": {
						"location": "querystring",
						"locationName": "includeValues",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"warnings": {
						"shape": "S8"
					},
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S6"
						}
					}
				}
			}
		},
		"GetAuthorizer": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"authorizerId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"authorizerId": {
						"location": "uri",
						"locationName": "authorizer_id"
					}
				}
			},
			"output": {
				"shape": "Se"
			}
		},
		"GetAuthorizers": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/authorizers"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "Se"
						}
					}
				}
			}
		},
		"GetBasePathMapping": {
			"http": {
				"method": "GET",
				"requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}"
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName",
					"basePath"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					},
					"basePath": {
						"location": "uri",
						"locationName": "base_path"
					}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"GetBasePathMappings": {
			"http": {
				"method": "GET",
				"requestUri": "/domainnames/{domain_name}/basepathmappings"
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "Sg"
						}
					}
				}
			}
		},
		"GetClientCertificate": {
			"http": {
				"method": "GET",
				"requestUri": "/clientcertificates/{clientcertificate_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"clientCertificateId"
				],
				"members": {
					"clientCertificateId": {
						"location": "uri",
						"locationName": "clientcertificate_id"
					}
				}
			},
			"output": {
				"shape": "S2k"
			}
		},
		"GetClientCertificates": {
			"http": {
				"method": "GET",
				"requestUri": "/clientcertificates"
			},
			"input": {
				"type": "structure",
				"members": {
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S2k"
						}
					}
				}
			}
		},
		"GetDeployment": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"deploymentId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"deploymentId": {
						"location": "uri",
						"locationName": "deployment_id"
					},
					"embed": {
						"shape": "S8",
						"location": "querystring",
						"locationName": "embed"
					}
				}
			},
			"output": {
				"shape": "Sl"
			}
		},
		"GetDeployments": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/deployments"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "Sl"
						}
					}
				}
			}
		},
		"GetDocumentationPart": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationPartId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationPartId": {
						"location": "uri",
						"locationName": "part_id"
					}
				}
			},
			"output": {
				"shape": "St"
			}
		},
		"GetDocumentationParts": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/documentation/parts"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"type": {
						"location": "querystring",
						"locationName": "type"
					},
					"nameQuery": {
						"location": "querystring",
						"locationName": "name"
					},
					"path": {
						"location": "querystring",
						"locationName": "path"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "St"
						}
					}
				}
			}
		},
		"GetDocumentationVersion": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationVersion"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationVersion": {
						"location": "uri",
						"locationName": "doc_version"
					}
				}
			},
			"output": {
				"shape": "Sv"
			}
		},
		"GetDocumentationVersions": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/documentation/versions"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "Sv"
						}
					}
				}
			}
		},
		"GetDomainName": {
			"http": {
				"method": "GET",
				"requestUri": "/domainnames/{domain_name}"
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					}
				}
			},
			"output": {
				"shape": "Sx"
			}
		},
		"GetDomainNames": {
			"http": {
				"method": "GET",
				"requestUri": "/domainnames"
			},
			"input": {
				"type": "structure",
				"members": {
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "Sx"
						}
					}
				}
			}
		},
		"GetExport": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/exports/{export_type}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName",
					"exportType"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					},
					"exportType": {
						"location": "uri",
						"locationName": "export_type"
					},
					"parameters": {
						"shape": "Sk",
						"location": "querystring"
					},
					"accepts": {
						"location": "header",
						"locationName": "Accept"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"contentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"contentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"body": {
						"type": "blob"
					}
				},
				"payload": "body"
			}
		},
		"GetIntegration": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					}
				}
			},
			"output": {
				"shape": "S1a"
			}
		},
		"GetIntegrationResponse": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					}
				}
			},
			"output": {
				"shape": "S1e"
			}
		},
		"GetMethod": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					}
				}
			},
			"output": {
				"shape": "S15"
			}
		},
		"GetMethodResponse": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					}
				}
			},
			"output": {
				"shape": "S18"
			}
		},
		"GetModel": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/models/{model_name}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"modelName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"modelName": {
						"location": "uri",
						"locationName": "model_name"
					},
					"flatten": {
						"location": "querystring",
						"locationName": "flatten",
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "Sz"
			}
		},
		"GetModelTemplate": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/models/{model_name}/default_template"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"modelName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"modelName": {
						"location": "uri",
						"locationName": "model_name"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"value": {}
				}
			}
		},
		"GetModels": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/models"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "Sz"
						}
					}
				}
			}
		},
		"GetRequestValidator": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"requestValidatorId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"requestValidatorId": {
						"location": "uri",
						"locationName": "requestvalidator_id"
					}
				}
			},
			"output": {
				"shape": "S11"
			}
		},
		"GetRequestValidators": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/requestvalidators"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S11"
						}
					}
				}
			}
		},
		"GetResource": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"embed": {
						"shape": "S8",
						"location": "querystring",
						"locationName": "embed"
					}
				}
			},
			"output": {
				"shape": "S13"
			}
		},
		"GetResources": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/resources"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"embed": {
						"shape": "S8",
						"location": "querystring",
						"locationName": "embed"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S13"
						}
					}
				}
			}
		},
		"GetRestApi": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					}
				}
			},
			"output": {
				"shape": "S1g"
			}
		},
		"GetRestApis": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis"
			},
			"input": {
				"type": "structure",
				"members": {
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S1g"
						}
					}
				}
			}
		},
		"GetSdk": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/sdks/{sdk_type}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName",
					"sdkType"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					},
					"sdkType": {
						"location": "uri",
						"locationName": "sdk_type"
					},
					"parameters": {
						"shape": "Sk",
						"location": "querystring"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"contentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"contentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"body": {
						"type": "blob"
					}
				},
				"payload": "body"
			}
		},
		"GetSdkType": {
			"http": {
				"method": "GET",
				"requestUri": "/sdktypes/{sdktype_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"id"
				],
				"members": {
					"id": {
						"location": "uri",
						"locationName": "sdktype_id"
					}
				}
			},
			"output": {
				"shape": "S4b"
			}
		},
		"GetSdkTypes": {
			"http": {
				"method": "GET",
				"requestUri": "/sdktypes"
			},
			"input": {
				"type": "structure",
				"members": {
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S4b"
						}
					}
				}
			}
		},
		"GetStage": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					}
				}
			},
			"output": {
				"shape": "S1i"
			}
		},
		"GetStages": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/stages"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"deploymentId": {
						"location": "querystring",
						"locationName": "deploymentId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"item": {
						"type": "list",
						"member": {
							"shape": "S1i"
						}
					}
				}
			}
		},
		"GetUsage": {
			"http": {
				"method": "GET",
				"requestUri": "/usageplans/{usageplanId}/usage"
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId",
					"startDate",
					"endDate"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"keyId": {
						"location": "querystring",
						"locationName": "keyId"
					},
					"startDate": {
						"location": "querystring",
						"locationName": "startDate"
					},
					"endDate": {
						"location": "querystring",
						"locationName": "endDate"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"shape": "S4m"
			}
		},
		"GetUsagePlan": {
			"http": {
				"method": "GET",
				"requestUri": "/usageplans/{usageplanId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					}
				}
			},
			"output": {
				"shape": "S1v"
			}
		},
		"GetUsagePlanKey": {
			"http": {
				"method": "GET",
				"requestUri": "/usageplans/{usageplanId}/keys/{keyId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId",
					"keyId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"keyId": {
						"location": "uri",
						"locationName": "keyId"
					}
				}
			},
			"output": {
				"shape": "S1x"
			}
		},
		"GetUsagePlanKeys": {
			"http": {
				"method": "GET",
				"requestUri": "/usageplans/{usageplanId}/keys"
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"nameQuery": {
						"location": "querystring",
						"locationName": "name"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S1x"
						}
					}
				}
			}
		},
		"GetUsagePlans": {
			"http": {
				"method": "GET",
				"requestUri": "/usageplans"
			},
			"input": {
				"type": "structure",
				"members": {
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"keyId": {
						"location": "querystring",
						"locationName": "keyId"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S1v"
						}
					}
				}
			}
		},
		"ImportApiKeys": {
			"http": {
				"requestUri": "/apikeys?mode=import",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"body",
					"format"
				],
				"members": {
					"body": {
						"type": "blob"
					},
					"format": {
						"location": "querystring",
						"locationName": "format"
					},
					"failOnWarnings": {
						"location": "querystring",
						"locationName": "failonwarnings",
						"type": "boolean"
					}
				},
				"payload": "body"
			},
			"output": {
				"type": "structure",
				"members": {
					"ids": {
						"shape": "S8"
					},
					"warnings": {
						"shape": "S8"
					}
				}
			}
		},
		"ImportDocumentationParts": {
			"http": {
				"method": "PUT",
				"requestUri": "/restapis/{restapi_id}/documentation/parts"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"body"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"mode": {
						"location": "querystring",
						"locationName": "mode"
					},
					"failOnWarnings": {
						"location": "querystring",
						"locationName": "failonwarnings",
						"type": "boolean"
					},
					"body": {
						"type": "blob"
					}
				},
				"payload": "body"
			},
			"output": {
				"type": "structure",
				"members": {
					"ids": {
						"shape": "S8"
					},
					"warnings": {
						"shape": "S8"
					}
				}
			}
		},
		"ImportRestApi": {
			"http": {
				"requestUri": "/restapis?mode=import",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"body"
				],
				"members": {
					"failOnWarnings": {
						"location": "querystring",
						"locationName": "failonwarnings",
						"type": "boolean"
					},
					"parameters": {
						"shape": "Sk",
						"location": "querystring"
					},
					"body": {
						"type": "blob"
					}
				},
				"payload": "body"
			},
			"output": {
				"shape": "S1g"
			}
		},
		"PutIntegration": {
			"http": {
				"method": "PUT",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"type"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"type": {},
					"integrationHttpMethod": {
						"locationName": "httpMethod"
					},
					"uri": {},
					"credentials": {},
					"requestParameters": {
						"shape": "Sk"
					},
					"requestTemplates": {
						"shape": "Sk"
					},
					"passthroughBehavior": {},
					"cacheNamespace": {},
					"cacheKeyParameters": {
						"shape": "S8"
					},
					"contentHandling": {}
				}
			},
			"output": {
				"shape": "S1a"
			}
		},
		"PutIntegrationResponse": {
			"http": {
				"method": "PUT",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					},
					"selectionPattern": {},
					"responseParameters": {
						"shape": "Sk"
					},
					"responseTemplates": {
						"shape": "Sk"
					},
					"contentHandling": {}
				}
			},
			"output": {
				"shape": "S1e"
			}
		},
		"PutMethod": {
			"http": {
				"method": "PUT",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"authorizationType"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"authorizationType": {},
					"authorizerId": {},
					"apiKeyRequired": {
						"type": "boolean"
					},
					"operationName": {},
					"requestParameters": {
						"shape": "S16"
					},
					"requestModels": {
						"shape": "Sk"
					},
					"requestValidatorId": {}
				}
			},
			"output": {
				"shape": "S15"
			}
		},
		"PutMethodResponse": {
			"http": {
				"method": "PUT",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					},
					"responseParameters": {
						"shape": "S16"
					},
					"responseModels": {
						"shape": "Sk"
					}
				}
			},
			"output": {
				"shape": "S18"
			}
		},
		"PutRestApi": {
			"http": {
				"method": "PUT",
				"requestUri": "/restapis/{restapi_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"body"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"mode": {
						"location": "querystring",
						"locationName": "mode"
					},
					"failOnWarnings": {
						"location": "querystring",
						"locationName": "failonwarnings",
						"type": "boolean"
					},
					"parameters": {
						"shape": "Sk",
						"location": "querystring"
					},
					"body": {
						"type": "blob"
					}
				},
				"payload": "body"
			},
			"output": {
				"shape": "S1g"
			}
		},
		"TestInvokeAuthorizer": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"authorizerId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"authorizerId": {
						"location": "uri",
						"locationName": "authorizer_id"
					},
					"headers": {
						"shape": "S5c"
					},
					"pathWithQueryString": {},
					"body": {},
					"stageVariables": {
						"shape": "Sk"
					},
					"additionalContext": {
						"shape": "Sk"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"clientStatus": {
						"type": "integer"
					},
					"log": {},
					"latency": {
						"type": "long"
					},
					"principalId": {},
					"policy": {},
					"authorization": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S8"
						}
					},
					"claims": {
						"shape": "Sk"
					}
				}
			}
		},
		"TestInvokeMethod": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"pathWithQueryString": {},
					"body": {},
					"headers": {
						"shape": "S5c"
					},
					"clientCertificateId": {},
					"stageVariables": {
						"shape": "Sk"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"status": {
						"type": "integer"
					},
					"body": {},
					"headers": {
						"shape": "S5c"
					},
					"log": {},
					"latency": {
						"type": "long"
					}
				}
			}
		},
		"UpdateAccount": {
			"http": {
				"method": "PATCH",
				"requestUri": "/account"
			},
			"input": {
				"type": "structure",
				"members": {
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "S2m"
			}
		},
		"UpdateApiKey": {
			"http": {
				"method": "PATCH",
				"requestUri": "/apikeys/{api_Key}"
			},
			"input": {
				"type": "structure",
				"required": [
					"apiKey"
				],
				"members": {
					"apiKey": {
						"location": "uri",
						"locationName": "api_Key"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "S6"
			}
		},
		"UpdateAuthorizer": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"authorizerId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"authorizerId": {
						"location": "uri",
						"locationName": "authorizer_id"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "Se"
			}
		},
		"UpdateBasePathMapping": {
			"http": {
				"method": "PATCH",
				"requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}"
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName",
					"basePath"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					},
					"basePath": {
						"location": "uri",
						"locationName": "base_path"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"UpdateClientCertificate": {
			"http": {
				"method": "PATCH",
				"requestUri": "/clientcertificates/{clientcertificate_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"clientCertificateId"
				],
				"members": {
					"clientCertificateId": {
						"location": "uri",
						"locationName": "clientcertificate_id"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "S2k"
			}
		},
		"UpdateDeployment": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"deploymentId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"deploymentId": {
						"location": "uri",
						"locationName": "deployment_id"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "Sl"
			}
		},
		"UpdateDocumentationPart": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationPartId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationPartId": {
						"location": "uri",
						"locationName": "part_id"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "St"
			}
		},
		"UpdateDocumentationVersion": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationVersion"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationVersion": {
						"location": "uri",
						"locationName": "doc_version"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "Sv"
			}
		},
		"UpdateDomainName": {
			"http": {
				"method": "PATCH",
				"requestUri": "/domainnames/{domain_name}"
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "Sx"
			}
		},
		"UpdateIntegration": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "S1a"
			}
		},
		"UpdateIntegrationResponse": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "S1e"
			}
		},
		"UpdateMethod": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "S15"
			}
		},
		"UpdateMethodResponse": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "S18"
			}
		},
		"UpdateModel": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/models/{model_name}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"modelName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"modelName": {
						"location": "uri",
						"locationName": "model_name"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "Sz"
			}
		},
		"UpdateRequestValidator": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"requestValidatorId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"requestValidatorId": {
						"location": "uri",
						"locationName": "requestvalidator_id"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "S11"
			}
		},
		"UpdateResource": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "S13"
			}
		},
		"UpdateRestApi": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "S1g"
			}
		},
		"UpdateStage": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "S1i"
			}
		},
		"UpdateUsage": {
			"http": {
				"method": "PATCH",
				"requestUri": "/usageplans/{usageplanId}/keys/{keyId}/usage"
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId",
					"keyId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"keyId": {
						"location": "uri",
						"locationName": "keyId"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "S4m"
			}
		},
		"UpdateUsagePlan": {
			"http": {
				"method": "PATCH",
				"requestUri": "/usageplans/{usageplanId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"patchOperations": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"shape": "S1v"
			}
		}
	},
	"shapes": {
		"S6": {
			"type": "structure",
			"members": {
				"id": {},
				"value": {},
				"name": {},
				"customerId": {},
				"description": {},
				"enabled": {
					"type": "boolean"
				},
				"createdDate": {
					"type": "timestamp"
				},
				"lastUpdatedDate": {
					"type": "timestamp"
				},
				"stageKeys": {
					"shape": "S8"
				}
			}
		},
		"S8": {
			"type": "list",
			"member": {}
		},
		"Sb": {
			"type": "list",
			"member": {}
		},
		"Se": {
			"type": "structure",
			"members": {
				"id": {},
				"name": {},
				"type": {},
				"providerARNs": {
					"shape": "Sb"
				},
				"authType": {},
				"authorizerUri": {},
				"authorizerCredentials": {},
				"identitySource": {},
				"identityValidationExpression": {},
				"authorizerResultTtlInSeconds": {
					"type": "integer"
				}
			}
		},
		"Sg": {
			"type": "structure",
			"members": {
				"basePath": {},
				"restApiId": {},
				"stage": {}
			}
		},
		"Sk": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"Sl": {
			"type": "structure",
			"members": {
				"id": {},
				"description": {},
				"createdDate": {
					"type": "timestamp"
				},
				"apiSummary": {
					"type": "map",
					"key": {},
					"value": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"members": {
								"authorizationType": {},
								"apiKeyRequired": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		},
		"Sq": {
			"type": "structure",
			"required": [
				"type"
			],
			"members": {
				"type": {},
				"path": {},
				"method": {},
				"statusCode": {},
				"name": {}
			}
		},
		"St": {
			"type": "structure",
			"members": {
				"id": {},
				"location": {
					"shape": "Sq"
				},
				"properties": {}
			}
		},
		"Sv": {
			"type": "structure",
			"members": {
				"version": {},
				"createdDate": {
					"type": "timestamp"
				},
				"description": {}
			}
		},
		"Sx": {
			"type": "structure",
			"members": {
				"domainName": {},
				"certificateName": {},
				"certificateArn": {},
				"certificateUploadDate": {
					"type": "timestamp"
				},
				"distributionDomainName": {}
			}
		},
		"Sz": {
			"type": "structure",
			"members": {
				"id": {},
				"name": {},
				"description": {},
				"schema": {},
				"contentType": {}
			}
		},
		"S11": {
			"type": "structure",
			"members": {
				"id": {},
				"name": {},
				"validateRequestBody": {
					"type": "boolean"
				},
				"validateRequestParameters": {
					"type": "boolean"
				}
			}
		},
		"S13": {
			"type": "structure",
			"members": {
				"id": {},
				"parentId": {},
				"pathPart": {},
				"path": {},
				"resourceMethods": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S15"
					}
				}
			}
		},
		"S15": {
			"type": "structure",
			"members": {
				"httpMethod": {},
				"authorizationType": {},
				"authorizerId": {},
				"apiKeyRequired": {
					"type": "boolean"
				},
				"requestValidatorId": {},
				"operationName": {},
				"requestParameters": {
					"shape": "S16"
				},
				"requestModels": {
					"shape": "Sk"
				},
				"methodResponses": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S18"
					}
				},
				"methodIntegration": {
					"shape": "S1a"
				}
			}
		},
		"S16": {
			"type": "map",
			"key": {},
			"value": {
				"type": "boolean"
			}
		},
		"S18": {
			"type": "structure",
			"members": {
				"statusCode": {},
				"responseParameters": {
					"shape": "S16"
				},
				"responseModels": {
					"shape": "Sk"
				}
			}
		},
		"S1a": {
			"type": "structure",
			"members": {
				"type": {},
				"httpMethod": {},
				"uri": {},
				"credentials": {},
				"requestParameters": {
					"shape": "Sk"
				},
				"requestTemplates": {
					"shape": "Sk"
				},
				"passthroughBehavior": {},
				"contentHandling": {},
				"cacheNamespace": {},
				"cacheKeyParameters": {
					"shape": "S8"
				},
				"integrationResponses": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S1e"
					}
				}
			}
		},
		"S1e": {
			"type": "structure",
			"members": {
				"statusCode": {},
				"selectionPattern": {},
				"responseParameters": {
					"shape": "Sk"
				},
				"responseTemplates": {
					"shape": "Sk"
				},
				"contentHandling": {}
			}
		},
		"S1g": {
			"type": "structure",
			"members": {
				"id": {},
				"name": {},
				"description": {},
				"createdDate": {
					"type": "timestamp"
				},
				"version": {},
				"warnings": {
					"shape": "S8"
				},
				"binaryMediaTypes": {
					"shape": "S8"
				}
			}
		},
		"S1i": {
			"type": "structure",
			"members": {
				"deploymentId": {},
				"clientCertificateId": {},
				"stageName": {},
				"description": {},
				"cacheClusterEnabled": {
					"type": "boolean"
				},
				"cacheClusterSize": {},
				"cacheClusterStatus": {},
				"methodSettings": {
					"type": "map",
					"key": {},
					"value": {
						"type": "structure",
						"members": {
							"metricsEnabled": {
								"type": "boolean"
							},
							"loggingLevel": {},
							"dataTraceEnabled": {
								"type": "boolean"
							},
							"throttlingBurstLimit": {
								"type": "integer"
							},
							"throttlingRateLimit": {
								"type": "double"
							},
							"cachingEnabled": {
								"type": "boolean"
							},
							"cacheTtlInSeconds": {
								"type": "integer"
							},
							"cacheDataEncrypted": {
								"type": "boolean"
							},
							"requireAuthorizationForCacheControl": {
								"type": "boolean"
							},
							"unauthorizedCacheControlHeaderStrategy": {}
						}
					}
				},
				"variables": {
					"shape": "Sk"
				},
				"documentationVersion": {},
				"createdDate": {
					"type": "timestamp"
				},
				"lastUpdatedDate": {
					"type": "timestamp"
				}
			}
		},
		"S1q": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"apiId": {},
					"stage": {}
				}
			}
		},
		"S1s": {
			"type": "structure",
			"members": {
				"burstLimit": {
					"type": "integer"
				},
				"rateLimit": {
					"type": "double"
				}
			}
		},
		"S1t": {
			"type": "structure",
			"members": {
				"limit": {
					"type": "integer"
				},
				"offset": {
					"type": "integer"
				},
				"period": {}
			}
		},
		"S1v": {
			"type": "structure",
			"members": {
				"id": {},
				"name": {},
				"description": {},
				"apiStages": {
					"shape": "S1q"
				},
				"throttle": {
					"shape": "S1s"
				},
				"quota": {
					"shape": "S1t"
				},
				"productCode": {}
			}
		},
		"S1x": {
			"type": "structure",
			"members": {
				"id": {},
				"type": {},
				"value": {},
				"name": {}
			}
		},
		"S2k": {
			"type": "structure",
			"members": {
				"clientCertificateId": {},
				"description": {},
				"pemEncodedCertificate": {},
				"createdDate": {
					"type": "timestamp"
				},
				"expirationDate": {
					"type": "timestamp"
				}
			}
		},
		"S2m": {
			"type": "structure",
			"members": {
				"cloudwatchRoleArn": {},
				"throttleSettings": {
					"shape": "S1s"
				},
				"features": {
					"shape": "S8"
				},
				"apiKeyVersion": {}
			}
		},
		"S4b": {
			"type": "structure",
			"members": {
				"id": {},
				"friendlyName": {},
				"description": {},
				"configurationProperties": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"name": {},
							"friendlyName": {},
							"description": {},
							"required": {
								"type": "boolean"
							},
							"defaultValue": {}
						}
					}
				}
			}
		},
		"S4m": {
			"type": "structure",
			"members": {
				"usagePlanId": {},
				"startDate": {},
				"endDate": {},
				"position": {},
				"items": {
					"locationName": "values",
					"type": "map",
					"key": {},
					"value": {
						"type": "list",
						"member": {
							"type": "list",
							"member": {
								"type": "long"
							}
						}
					}
				}
			}
		},
		"S5c": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S5i": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"op": {},
					"path": {},
					"value": {},
					"from": {}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/apigateway-2015-07-09.min.json
// module id = 349
// module chunks = 0